import { useEffect } from 'react'
import { useFormikContext } from 'formik'

const ScrollToFormError = () => {
  const { submitCount, isValid, errors } = useFormikContext()

  useEffect(() => {
    if (isValid) return

    let erroredElementsOffset: number[] = []
    Object.keys(errors).forEach(key => {
      const el = document.querySelector(`[data-formik-error="${key}"]`)
      if (el) erroredElementsOffset.push(el.getBoundingClientRect().top)
    })

    window.scrollTo({
      top: window.pageYOffset + Math.min(...erroredElementsOffset),
      behavior: 'smooth',
    })
  }, [submitCount, errors]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default ScrollToFormError
